module.exports = __webpack_public_path__ + "static/media/6-item-d.714d63b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/6-item-d.jpg
// module id = 1204
// module chunks = 33